import React from "react";
import { TaskAlt as TaskAltIcon } from "@mui/icons-material";
import { ConfirmDialog } from "../../shared/ui";

interface SignOffDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SignOffDialog: React.FC<SignOffDialogProps> = ({ open, onClose, onConfirm }) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      tone="success"
      iconVariant="tinted"
      icon={<TaskAltIcon />}
      title="Approve Template"
      description="This will save the template for your department. Future generated
        reports can use this format."
      confirmLabel="Approve & Save"
      cancelLabel="Go Back"
    />
  );
};

export default SignOffDialog;
